import PermissionPage from "./PermissionPage";

const PermissionConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: ["canReadSettings"],
  routes: [
    {
      path: "settings/access-management",
      element: <PermissionPage />,
    },
  ],
};

export default PermissionConfig;
